import { useQuery } from "@apollo/client";
import { Query } from "@/app/graphql/codegen";
import { FETCH_CONTEXT_SELECTION_FOR_CHAT } from "@chat/graphql/queries/fetchContextSelectionForChat";

export interface ChatModes {
  isGraphEnabled: boolean;
  isGptOnlyEnabled: boolean;
  isDocumentSelectionDisabled: boolean;
}

export const useChatModes = (chatId: string | null | undefined): ChatModes => {
    const { data } = useQuery<Pick<Query, "contextForChat">>(FETCH_CONTEXT_SELECTION_FOR_CHAT, {
        variables: { chatId: chatId || "" },
        skip: !chatId || chatId === ""
    });

    const context = data?.contextForChat;
    const isGptOnlyEnabled = Boolean((context as any)?.gptOnlyEnabled);
    const isGraphEnabled = Boolean(context?.graphEnabled && !isGptOnlyEnabled);
    const isDocumentSelectionDisabled = false; // Keep document selection always enabled

    return {
        isGraphEnabled,
        isGptOnlyEnabled,
        isDocumentSelectionDisabled
    };
};